import axios from "axios";

export const BASE_URL = "https://immersive-game-india.confirmu.com";

export let headers = {
  "Tenant-Access-Token": "MmJmNTY5NDFjYjliNjNjMjJlZGQ3Zjg4ZmE4N2JjZGU=",
  "Tenant-Access-Key": "KrQJwFrXK8qY8w",
};


export const api = axios.create({
  baseURL: BASE_URL,
  headers,
});
